
import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import DeadlineItem, { DeadlineItemProps } from './DeadlineItem';

interface DeadlinesCalendarProps {
  deadlines: DeadlineItemProps[];
}

const DeadlinesCalendar: React.FC<DeadlinesCalendarProps> = ({ deadlines }) => {
  return (
    <Card className="md:col-span-2">
      <CardHeader>
        <CardTitle>Smart Compliance Calendar</CardTitle>
        <CardDescription>
          Upcoming regulatory deadlines and compliance tasks
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {deadlines.map((deadline) => (
            <DeadlineItem 
              key={deadline.id}
              id={deadline.id}
              name={deadline.name}
              deadline={deadline.deadline}
              category={deadline.category}
              status={deadline.status}
            />
          ))}
          <Button variant="outline" className="w-full mt-2">View All Deadlines</Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default DeadlinesCalendar;
